import styles from "./Button.module.css";

const Button = ({
    children,
    type = "button",
    variant = "primary",
    size = "md",
    fullWidth = false,
    rounded = false,
    circle = false,
    loading = false,
    disabled = false,
    icon = null,
    iconPosition = "left",
    className = "",
    onClick,
}) => {

    const classes = [

        styles.button,

        styles[variant],

        styles[size],

        fullWidth ? styles.fullWidth : "",

        rounded ? styles.rounded : "",

        circle ? styles.circle : "",

        loading ? styles.loading : "",

        className,

    ].join(" ");

    return (

        <button

            type={type}

            disabled={disabled || loading}

            className={classes}

            onClick={onClick}

        >

            {loading && (

                <span className={styles.spinner}></span>

            )}

            {!loading && icon && iconPosition === "left" && (

                <span className={styles.icon}>

                    {icon}

                </span>

            )}

            {!circle && (

                <span>

                    {loading ? "در حال ارسال..." : children}

                </span>

            )}

            {!loading && icon && iconPosition === "right" && (

                <span className={styles.icon}>

                    {icon}

                </span>

            )}

            {circle && icon}

        </button>

    );

};

export default Button;